import {
  SET_CURRENT_VIEW,
} from '../actions/viewActions'

export const defaultState = {
  currentView: '',
}

export default (state = defaultState, action) => {
  const newState = Object.assign({}, state)

  switch (action.type) {
    case SET_CURRENT_VIEW:
      newState.currentView = action.payload
      return newState

    default:
      return state
  }
};
